import commonParam from "../param/commonParam";

export function setData(key, data) {
  let tk = transKey(key);
  try {
    localStorage.setItem(tk, JSON.stringify(data));
  } catch (e) {
    localStorage.setItem(tk, data);
  }
}

export function setDataSS(key, data) {
  let tk = transKey(key);
  try {
    sessionStorage.setItem(tk, JSON.stringify(data));
  } catch (e) {
    sessionStorage.setItem(tk, data);
  }
}

export function getData(key) {
  let tk = transKey(key);
  let jsonStr = localStorage.getItem(tk);
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return jsonStr;
  }
}

export function getDataSS(key) {
  let tk = transKey(key);
  let jsonStr = sessionStorage.getItem(tk);
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return jsonStr;
  }
}

export function delData(key) {
  let tk = transKey(key);
  localStorage.removeItem(tk);
}

export function clearData() {
  localStorage.clear();
  sessionStorage.clear();
}

function transKey (key) {
    return commonParam.systemName + "." + key;
}
